// Toggle .is-hovered / .is-focused on a product card when its image or title is
// hovered/focused, so the title-underline + image-lift effects can use cheap class
// selectors instead of .product-card:has(:hover). :has(:hover) forces the browser to
// re-run style invalidation on every pointer move for every card subject, which gets
// slow once infinite scroll has appended hundreds of cards. pointerenter/leave (here
// via delegated pointerover/out) only fire on boundary crossings, so cost stays flat.
//
// Loaded globally from layout/theme.liquid (not via a {% javascript %} component tag)
// so it also covers AJAX-hydrated cards (e.g. product recommendations) whose host
// section isn't server-rendered with cards on first paint.
(() => {
  if (window.__productCardHoverInit) return;
  window.__productCardHoverInit = true;

  const TRIGGER = '.card-gallery, [ref="productTitleLink"], .product-grid-view-zoom-out--details';
  const triggerFor = (el) => (el && el.closest ? el.closest(TRIGGER) : null);
  const cardOf = (el) => (el && el.closest ? el.closest('product-card, .product-card') : null);

  document.addEventListener(
    'pointerover',
    (event) => {
      const trigger = triggerFor(event.target);
      if (trigger) cardOf(trigger)?.classList.add('is-hovered');
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      const trigger = triggerFor(event.target);
      if (!trigger) return;
      const card = cardOf(trigger);
      if (!card) return;
      // Keep the state if the pointer is moving to another trigger of the same card.
      const next = triggerFor(event.relatedTarget);
      if (next && cardOf(next) === card) return;
      card.classList.remove('is-hovered');
    },
    { passive: true }
  );

  document.addEventListener('focusin', (event) => {
    const target = event.target;
    const focusable = triggerFor(target) || (target.closest ? target.closest('.product-card__link') : null);
    if (focusable && target.matches?.(':focus-visible')) {
      cardOf(focusable)?.classList.add('is-focused');
    }
  });

  document.addEventListener('focusout', (event) => {
    cardOf(event.target)?.classList.remove('is-focused');
  });
})();
